'use strict';
const angular = require('angular');

/*@ngInject*/
export function ReservationService($resource) {
  return $resource('/api/reservations/:id', {
    id: '@_id'
  },{
    getByTypeAndState: {
      method: 'GET',
      url: "/api/reservations/type/:type/state/:state",
      isArray: true
    },
    getUpcomingByUserAndType: {
      method: 'GET',
      url: "/api/reservations/type/:type/user/:userId/upcoming",
      isArray: true
    },
    getPastByUserAndType: {
      method: 'GET',
      url: "/api/reservations/type/:type/user/:userId/past",
      isArray: true
    },
    getSpotsReserved: {
      method: 'GET',
      url: "/api/reservations/spots-reserved/:id"
    },
    getEventReservation: {
      method: 'GET',
      url: "/api/reservations/:event/:user"
    },
    getByEvent: {
      method: 'GET',
      url: "/api/reservations/event/:event",
      isArray: true
    },
    getByUser: {
      method: 'GET',
      url: "/api/reservations/user/:user",
      isArray: true
    },
    patch: {
      method: 'PATCH'
    },
    update: {
      method: 'PUT'
    },
    setState: {
      method: 'PUT',
      url: "/api/reservations/:id/state"
    }
  });
}


export default angular.module('conduuApp.ReservationService', [])
  .factory('ReservationService', ReservationService)
  .name;



// WEBPACK FOOTER //
// ./client/services/reservation/reservation.service.js